/**
 * Build a schema.org FAQPage node from the FAQ component's entries.
 *
 * Only entries that carry both a question and an answer become `Question`
 * nodes — half-filled entries are skipped so we never emit an `Answer`
 * with empty `text`, which the Google Rich Results Test rejects. When no
 * entry qualifies (or `entries` is undefined) the whole node is omitted.
 */
const buildFaqSchema = (entries = []) => {
  const questions = entries.filter((entry) => entry.question && entry.answer)
  if (questions.length === 0) return null

  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: questions.map((entry) => ({
      "@type": "Question",
      name: entry.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: entry.answer,
      },
    })),
  }
}

export default buildFaqSchema
